import { Link } from 'react-router-dom';
import styled from 'styled-components';
const utilities = require("./utilities");

const TokenLink = styled(Link)`
display:block;
margin-bottom :10px;
&:focus, &:hover, &:visited, &:link, &:active {
    color:#fff;
}
&:hover{
    color:#00ff00;
}
`;


const PalaceTokenCard = ({tokens}) => (
        <div className='tokenBox'>
            <div className='MytokenCard'><img src={`data:image/svg+xml;base64,${btoa(tokens.image)}`} alt={`${tokens.name}`}/></div>
            <div className='MainTokenInfo'>
                <TokenLink to={`/cypherpalace/${tokens.tokenId}`} className='TokenName'>{tokens.name}</TokenLink>
            </div>
        </div>
    )
export default PalaceTokenCard;
